export const UTM_SOURCE_COOKIE_NAME = 'HEYFORM_UTM_SOURCE'
